import { Box, Typography } from '@mui/material';

import { Card, Section } from './Card';
import { COLORS } from './constants';

const BASIS_NOTE = {
  own_history: 'Built from your recent sessions and your targets.',
  defaults: 'Built from your targets while we gather more session history.',
};

const NextSession = ({ nextSession }) => {
  const items = Array.isArray(nextSession?.items) ? nextSession.items : [];
  return (
    <Section title="Next session" id="perf-next-session">
      <Card>
        {nextSession?.summary && (
          <Typography sx={{ fontSize: 15 }}>{nextSession.summary}</Typography>
        )}
        <Typography sx={{ mt: 1, fontSize: 13, opacity: 0.8 }}>
          {BASIS_NOTE[nextSession?.basis] || BASIS_NOTE.defaults}
        </Typography>
        {items.length > 0 && (
          <Box component="ul" aria-label="Suggested sets per lift" sx={{ p: 0, m: 0, mt: 2 }}>
            {items.map((item) => (
              <Box
                component="li"
                key={item.exerciseName}
                sx={{ listStyle: 'none', py: 1, borderTop: `1px solid ${COLORS.border}` }}
              >
                <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
                  {item.label}
                  <Box component="span" sx={{ ml: 1, fontWeight: 600 }}>
                    {item.suggestedSets} {item.suggestedSets === 1 ? 'set' : 'sets'}
                  </Box>
                </Typography>
                {item.reason && (
                  <Typography sx={{ fontSize: 14, opacity: 0.85 }}>{item.reason}</Typography>
                )}
              </Box>
            ))}
          </Box>
        )}
        {Number.isFinite(nextSession?.totalSets) && (
          <Typography sx={{ mt: 2, fontWeight: 700 }}>
            Total: {nextSession.totalSets} sets
          </Typography>
        )}
      </Card>
    </Section>
  );
};

export default NextSession;
